export default function SectionSubtitle({ children, className = "", style = {} }) {
  return (
    <p
      className={`font-body text-sm leading-[1.8] max-w-sm mt-4 lg:mt-0 ${className}`}
      style={{ color: "rgba(242,232,216,0.55)", ...style }}
    >
      {children}
    </p>
  );
}